import React from 'react';
import { Wrench, ArrowLeft, ShieldCheck, FileText } from 'lucide-react';
import { useT } from '../context/LanguageContext';
import { useDocumentMeta } from '../lib/useDocumentMeta';
import './LegalPage.css';

const CONTACT = {
  naam: 'MonteurCentraal',
  email: 'info@monteurcentraal.com',
  // Vul deze gegevens aan zodra je KvK-inschrijving rond is:
  kvk: '',
  adres: '',
};

const LAATST = '14 juni 2026';

function Privacy({ t }) {
  return (
    <>
      <h1><ShieldCheck size={26} /> {t('Privacyverklaring')}</h1>
      <p className="lg-meta">{t('Laatst bijgewerkt:')} {LAATST}</p>

      <p>{t('MonteurCentraal hecht veel waarde aan de bescherming van persoonsgegevens. In deze privacyverklaring leggen we uit welke gegevens we verwerken, waarom, en welke rechten je hebt. Wij verwerken persoonsgegevens in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG).')}</p>

      <h2>{t('1. Wie zijn wij?')}</h2>
      <p>{t('MonteurCentraal (hierna "wij" of "MonteurCentraal") levert software waarmee autobedrijven hun administratie, planning en facturatie beheren.')}</p>
      <ul>
        <li><b>{t('Contact:')}</b> {CONTACT.email}</li>
      </ul>

      <h2>{t('2. Rolverdeling (verwerker vs. verwerkingsverantwoordelijke)')}</h2>
      <p>{t('Voor de gegevens die een aangesloten garage in MonteurCentraal invoert (zoals klant- en voertuiggegevens) is de garage de verwerkingsverantwoordelijke en treedt MonteurCentraal op als verwerker. Wij verwerken die gegevens uitsluitend in opdracht van de garage en voor het leveren van de dienst. Voor de gegevens van de garage zelf (account, facturatie, licentie) zijn wij verwerkingsverantwoordelijke.')}</p>

      <h2>{t('3. Welke gegevens verwerken we?')}</h2>
      <ul>
        <li><b>{t('Accountgegevens garage:')}</b> {t('naam, e-mailadres, bedrijfsgegevens, inloggegevens (versleuteld).')}</li>
        <li><b>{t('Gebruiks- en apparaatgegevens:')}</b> {t('IP-adres, browser/apparaat, activiteitstijdstippen (voor beveiliging en het activatielogboek van je licentie).')}</li>
        <li><b>{t('Klant- en voertuiggegevens (ingevoerd door de garage):')}</b> {t('naam, contactgegevens, kenteken, voertuig- en reparatiegegevens.')}</li>
        <li><b>{t('Afspraakgegevens:')}</b> {t('gegevens die klanten invoeren bij online afspraken.')}</li>
        <li><b>{t('Betaal-/licentiegegevens:')}</b> {t('bestelreferentie, e-mailadres, gekozen pakket.')}</li>
      </ul>

      <h2>{t('4. Doeleinden en grondslag')}</h2>
      <ul>
        <li>{t('Het leveren en beveiligen van de dienst (uitvoering overeenkomst).')}</li>
        <li>{t('Facturatie en licentiebeheer (uitvoering overeenkomst / wettelijke plicht).')}</li>
        <li>{t('Het versturen van afspraak-, herinnerings- en servicemails (uitvoering overeenkomst).')}</li>
        <li>{t('Fraude- en misbruikpreventie (gerechtvaardigd belang).')}</li>
      </ul>

      <h2>{t('5. Verstrekking aan derden (sub-verwerkers)')}</h2>
      <p>{t('Wij delen gegevens alleen met partijen die nodig zijn om de dienst te leveren:')}</p>
      <ul>
        <li><b>RDW / PDOK</b> — {t('kentekens en voertuiggegevens opvragen (openbare data).')}</li>
        <li><b>Resend</b> — {t('versturen van e-mails (afspraken, herinneringen, licenties).')}</li>
        <li><b>Dropbox / Google Drive</b> — {t('alleen als de garage zelf cloud back-up koppelt.')}</li>
        <li><b>{t('Hostingprovider')}</b> — {t('voor het draaien van de applicatie en database.')}</li>
      </ul>
      <p>{t('Wij verkopen je gegevens nooit aan derden.')}</p>

      <h2>{t('6. Bewaartermijnen')}</h2>
      <p>{t('We bewaren gegevens niet langer dan nodig. Facturatiegegevens bewaren we conform de wettelijke fiscale bewaarplicht (7 jaar). Apparaatregistraties die 90 dagen niet zijn gebruikt worden automatisch verwijderd. Bij beëindiging van het account verwijderen of anonimiseren we persoonsgegevens binnen een redelijke termijn, behoudens wettelijke verplichtingen.')}</p>

      <h2>{t('7. Beveiliging')}</h2>
      <p>{t('We nemen passende technische en organisatorische maatregelen, waaronder versleutelde wachtwoorden, toegangsbeperking per garage (multi-tenant isolatie) en versleutelde verbindingen (HTTPS).')}</p>

      <h2>{t('8. Jouw rechten')}</h2>
      <p>{t('Je hebt recht op inzage, correctie, verwijdering, beperking en overdraagbaarheid van je persoonsgegevens, en het recht bezwaar te maken. Neem hiervoor contact op via')} {CONTACT.email}. {t('Je kunt ook een klacht indienen bij de Autoriteit Persoonsgegevens.')}</p>

      <h2>{t('9. Cookies')}</h2>
      <p>{t('We gebruiken alleen functionele opslag (zoals een lokale apparaat-id en je inlogsessie) die noodzakelijk is voor de werking van de applicatie. We gebruiken geen tracking- of advertentiecookies.')}</p>

      <h2>{t('10. Wijzigingen')}</h2>
      <p>{t('We kunnen deze privacyverklaring aanpassen. De meest actuele versie vind je altijd op deze pagina.')}</p>

     
    </>
  );
}

function Voorwaarden({ t }) {
  return (
    <>
      <h1><FileText size={26} /> {t('Algemene Voorwaarden MonteurCentraal')}</h1>
      <p className="lg-meta">{t('Laatst bijgewerkt:')} {LAATST}</p>

      <p>{t('Deze algemene voorwaarden zijn van toepassing op ieder gebruik van de software, website, diensten en functionaliteiten van MonteurCentraal.')}</p>
      <p>{t('Door een account aan te maken of gebruik te maken van de dienst verklaart de gebruiker akkoord te gaan met deze voorwaarden.')}</p>

      <h2>{t('1. Toepasselijkheid')}</h2>
      <p>{t('Deze voorwaarden gelden voor alle gebruikers van MonteurCentraal. Indien een bepaling ongeldig blijkt te zijn, blijven de overige bepalingen volledig van kracht.')}</p>

      <h2>{t('2. Definities')}</h2>
      <ul>
        <li><b>{t('MonteurCentraal:')}</b> {t('de aanbieder van de software en bijbehorende diensten.')}</li>
        <li><b>{t('Dienst:')}</b> {t('de online software (SaaS), website, API’s, mobiele toepassingen, AI-functionaliteiten en overige diensten van MonteurCentraal.')}</li>
        <li><b>{t('Klant:')}</b> {t('iedere natuurlijke persoon of rechtspersoon die gebruikmaakt van de dienst.')}</li>
        <li><b>{t('Account:')}</b> {t('de persoonlijke toegang tot de dienst.')}</li>
        <li><b>{t('Licentie:')}</b> {t('het recht om de dienst te gebruiken binnen de grenzen van het gekozen pakket.')}</li>
        <li><b>{t('AI-functionaliteiten:')}</b> {t('alle functies waarbij automatisch gegevens, teksten, berekeningen, analyses of herkenningen worden gegenereerd.')}</li>
      </ul>

      <h2>{t('3. Beschrijving van de dienst')}</h2>
      <p>{t('MonteurCentraal biedt software voor onder andere klantenbeheer, voertuigbeheer, werkbonnen, offertes, facturen, boekhouding, planning, online afspraken, voorraadbeheer, onderdelenbeheer, handelauto’s, rapportages, cloudopslag en AI-functionaliteiten.')}</p>
      <p>{t('De exacte inhoud van de dienst kan op ieder moment worden aangepast, uitgebreid of gewijzigd.')}</p>

      <h2>{t('4. Account en toegang')}</h2>
      <ul>
        <li>{t('De klant is verantwoordelijk voor het geheimhouden van inloggegevens.')}</li>
        <li>{t('De klant is verantwoordelijk voor alle activiteiten die plaatsvinden onder het eigen account.')}</li>
        <li>{t('Het delen van accounts, licenties of toegangsgegevens met derden is niet toegestaan, tenzij dit uitdrukkelijk is toegestaan binnen het gekozen pakket.')}</li>
        <li>{t('MonteurCentraal mag accounts blokkeren of verwijderen bij misbruik, fraude, spam, beveiligingsrisico’s of overtreding van deze voorwaarden.')}</li>
      </ul>

      <h2>{t('5. Licenties')}</h2>
      <ul>
        <li>{t('Een licentie geeft uitsluitend een gebruiksrecht. De software wordt niet verkocht.')}</li>
        <li>{t('Licenties zijn niet overdraagbaar zonder schriftelijke toestemming van MonteurCentraal.')}</li>
        <li>{t('MonteurCentraal mag technische maatregelen treffen ter bescherming van licenties, gebruikersaantallen en apparaten.')}</li>
      </ul>

      <h2>{t('6. Proefversies en gratis pakketten')}</h2>
      <p>{t('Gratis pakketten, proefperiodes en promoties kunnen op ieder moment worden gewijzigd, beperkt of beëindigd.')}</p>
      <p>{t('MonteurCentraal behoudt zich het recht voor proefaccounts te weigeren of te beëindigen bij vermoedens van misbruik.')}</p>

      <h2>{t('7. Prijzen en betaling')}</h2>
      <ul>
        <li>{t('Prijzen staan vermeld op de website.')}</li>
        <li>{t('Betaling vindt plaats via de aangeboden betaalmethoden.')}</li>
        <li>{t('Licenties worden geactiveerd nadat betaling is ontvangen.')}</li>
        <li>{t('Bij uitblijven van betaling kan toegang tot de dienst worden beperkt of beëindigd.')}</li>
        <li>{t('Prijswijzigingen kunnen op ieder moment worden doorgevoerd voor toekomstige periodes.')}</li>
      </ul>

      <h2>{t('8. Gegevens en eigendom')}</h2>
      <p>{t('Alle gegevens die door de klant worden ingevoerd blijven eigendom van de klant. MonteurCentraal verkrijgt geen eigendomsrechten op klantgegevens.')}</p>
      <p>{t('De klant blijft volledig verantwoordelijk voor ingevoerde gegevens, documenten, afbeeldingen, voertuiginformatie, klantinformatie en boekhoudkundige gegevens.')}</p>

      <h2>{t('9. Back-ups')}</h2>
      <p>{t('Hoewel MonteurCentraal maatregelen neemt om gegevensverlies te voorkomen, wordt geen garantie gegeven dat gegevens nooit verloren gaan.')}</p>
      <p>{t('De klant blijft zelf verantwoordelijk voor het regelmatig maken en controleren van back-ups. MonteurCentraal is niet aansprakelijk voor verlies van gegevens, ongeacht de oorzaak.')}</p>

      <h2>{t('10. AI-functionaliteiten')}</h2>
      <p>{t('MonteurCentraal kan gebruikmaken van AI-functionaliteiten, waaronder advertentiegeneratie, documentherkenning, kentekenbewijsherkenning, voertuigherkenning, onderdelenherkenning, tekstgeneratie, analyses en suggesties.')}</p>
      <p>{t('AI-functionaliteiten worden uitsluitend aangeboden als hulpmiddel. MonteurCentraal geeft geen garantie over juistheid, volledigheid, actualiteit, geschiktheid of betrouwbaarheid.')}</p>
      <p>{t('Alle door AI gegenereerde gegevens dienen altijd door de gebruiker te worden gecontroleerd voordat deze worden gebruikt. Gebruik van AI-functionaliteiten geschiedt volledig op eigen risico.')}</p>

      <h2>{t('11. Externe gegevensbronnen')}</h2>
      <p>{t('MonteurCentraal kan gegevens ophalen of verwerken via externe diensten zoals RDW, PDOK, Dropbox, Google Drive, e-mailproviders, AI-diensten, hostingproviders en betaaldiensten.')}</p>
      <p>{t('MonteurCentraal is niet verantwoordelijk voor fouten, vertragingen, wijzigingen of storingen bij dergelijke externe partijen.')}</p>

      <h2>{t('12. Beschikbaarheid')}</h2>
      <p>{t('MonteurCentraal streeft naar een zo hoog mogelijke beschikbaarheid, maar geeft geen garantie op foutloze werking, continue beschikbaarheid of afwezigheid van storingen.')}</p>
      <p>{t('Onderhoudswerkzaamheden mogen zonder voorafgaande aankondiging worden uitgevoerd.')}</p>

      <h2>{t('13. Intellectueel eigendom')}</h2>
      <p>{t('Alle intellectuele eigendomsrechten met betrekking tot software, broncode, ontwerpen, databases, documentatie, logo’s en handelsnamen blijven eigendom van MonteurCentraal.')}</p>
      <p>{t('De klant verkrijgt uitsluitend een beperkt gebruiksrecht.')}</p>

      <h2>{t('14. Verboden gebruik')}</h2>
      <ul>
        <li>{t('Het is niet toegestaan beveiligingen te omzeilen.')}</li>
        <li>{t('Het is niet toegestaan de software te reverse-engineeren.')}</li>
        <li>{t('Het is niet toegestaan de dienst te misbruiken of schadelijke software te verspreiden.')}</li>
        <li>{t('Het is niet toegestaan onrechtmatige gegevens op te slaan of rechten van derden te schenden.')}</li>
      </ul>

      <h2>{t('15. Vrijwaring')}</h2>
      <p>{t('De klant vrijwaart MonteurCentraal tegen alle aanspraken van derden die voortvloeien uit het gebruik van de dienst, ingevoerde gegevens, gegenereerde documenten, advertenties, facturen, boekhoudkundige gegevens, klantgegevens of voertuiggegevens.')}</p>
      <p>{t('Eventuele juridische kosten en schade voortvloeiend uit dergelijke aanspraken komen voor rekening van de klant.')}</p>

      <h2>{t('16. Aansprakelijkheid')}</h2>
      <p>{t('MonteurCentraal levert de dienst op basis van een inspanningsverplichting.')}</p>
      <p>{t('MonteurCentraal is niet aansprakelijk voor indirecte schade, gevolgschade, omzetverlies, winstderving, bedrijfsschade, verlies van klanten, verlies van gegevens, fiscale schade, naheffingen, boetes, gemiste afspraken, onjuiste berekeningen, onjuiste AI-resultaten, onjuiste voertuiggegevens, onjuiste kentekengegevens, fouten van externe diensten of gebruikersfouten.')}</p>
      <p>{t('Voor zover aansprakelijkheid wettelijk niet kan worden uitgesloten, is de totale aansprakelijkheid beperkt tot het laagste van het bedrag dat de klant gedurende de twaalf maanden voorafgaand aan de gebeurtenis heeft betaald of €500.')}</p>
      <p>{t('Deze beperking geldt niet voor aansprakelijkheid die volgens Nederlands recht niet mag worden uitgesloten.')}</p>

      <h2>{t('17. Overmacht')}</h2>
      <p>{t('MonteurCentraal is niet aansprakelijk voor tekortkomingen veroorzaakt door overmacht, waaronder internetstoringen, stroomuitval, cyberaanvallen, DDoS-aanvallen, storingen bij cloudproviders, storingen bij AI-diensten, storingen bij betaalproviders, overheidsmaatregelen, natuurrampen, oorlog of arbeidsconflicten.')}</p>

      <h2>{t('18. Beëindiging')}</h2>
      <p>{t('De klant kan het gebruik van de dienst op ieder moment beëindigen.')}</p>
      <p>{t('MonteurCentraal kan accounts opschorten of beëindigen bij wanbetaling, fraude, misbruik, overtreding van deze voorwaarden of beveiligingsrisico’s.')}</p>

      <h2>{t('19. Wijzigingen')}</h2>
      <p>{t('MonteurCentraal mag deze voorwaarden op ieder moment wijzigen. De meest actuele versie wordt gepubliceerd op de website.')}</p>
      <p>{t('Voortgezet gebruik van de dienst geldt als aanvaarding van de gewijzigde voorwaarden.')}</p>

      <h2>{t('20. Toepasselijk recht')}</h2>
      <p>{t('Op deze voorwaarden is uitsluitend Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in Nederland.')}</p>

      <h2>{t('21. Contact')}</h2>
      <p>{t('Vragen over deze voorwaarden kunnen worden gestuurd naar')} {CONTACT.email}.</p>
    </>
  );
}

export default function LegalPage({ doc }) {
  const { t } = useT();
  const isPrivacy = doc === 'privacy';
  useDocumentMeta(
    isPrivacy ? 'Privacyverklaring — MonteurCentraal' : 'Algemene voorwaarden — MonteurCentraal',
    isPrivacy
      ? 'Lees hoe MonteurCentraal persoonsgegevens verwerkt en beschermt conform de AVG: welke gegevens, waarom, en welke rechten je hebt.'
      : 'De algemene voorwaarden van MonteurCentraal: gebruik van de garagesoftware, abonnementen, betalingen, aansprakelijkheid en opzegging.',
    isPrivacy ? '/privacy' : '/voorwaarden',
  );
  return (
    <div className="lg-wrap" data-testid={`legal-${doc}`}>
      <div className="lg-shell">
        <a href="/" className="lg-home"><ArrowLeft size={15} /> {t('Terug naar MonteurCentraal')}</a>
        <div className="lg-brand"><div className="lg-logo"><Wrench size={18} /></div> MonteurCentraal</div>
        <div className="lg-card">
          {doc === 'privacy' ? <Privacy t={t} /> : <Voorwaarden t={t} />}
        </div>
        <div className="lg-foot">
          <a href="/privacy">{t('Privacyverklaring')}</a> · <a href="/voorwaarden">{t('Algemene voorwaarden')}</a>
        </div>
      </div>
    </div>
  );
}
